// The first step of adding a secret: one card per type template, with its icon and a line on
// what it holds (design/isomorphic/src/pages/secret-drawer.tsx).
import {
  BracketsCurly,
  CheckSquare,
  Cursor,
  Database,
  GithubLogo,
  type Icon,
  Kanban,
  Key,
  ShieldCheck,
  SlackLogo,
  Sparkle,
} from "@phosphor-icons/react";

import { useT } from "../i18n";
import { cn } from "../ui/cn";
import { type TemplateId, TEMPLATES } from "./templates";

export const TEMPLATE_ICON: Record<TemplateId, Icon> = {
  github: GithubLogo,
  anthropic_api_key: Sparkle,
  claude_subscription: Sparkle,
  jira: Kanban,
  asana: CheckSquare,
  cursor_api_key: Cursor,
  slack: SlackLogo,
  database: Database,
  http_api_key: BracketsCurly,
  vpn_profile: ShieldCheck,
  other: Key,
};

/** The template's icon on a tinted tile, as the list and the picker show it. */
export function TemplateIcon({ id, className }: { id: TemplateId | undefined; className?: string }) {
  const Glyph = id ? TEMPLATE_ICON[id] : Key;
  return (
    <span className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-800", className)}>
      <Glyph weight="duotone" className="h-5 w-5" />
    </span>
  );
}

export function TemplatePicker({ onPick }: { onPick: (id: TemplateId) => void }) {
  const hint = useT().secrets.templates.hint;
  return (
    <div className="grid grid-cols-2 gap-3">
      {TEMPLATES.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onPick(t.id)}
          className="flex flex-col items-start gap-2 rounded-xl border border-muted p-3.5 text-start transition-colors hover:border-primary hover:bg-primary-lighter/30"
        >
          <TemplateIcon id={t.id} />
          <span className="font-semibold text-gray-900">{t.label}</span>
          <span className="text-xs leading-snug text-gray-500">{hint[t.id]}</span>
        </button>
      ))}
    </div>
  );
}
